"use client";

import { NewsletterSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import HomeSixSubscribeSectionGenerated, {
  HomeSixSubscribeSectionGeneratedProps,
} from "../Sections/_generated/HomeSixSubscribeSection.generated";
import FooterNewsletterForm from "./FooterNewsletterForm";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

const GeneratedNewsletterSection: FC<NewsletterSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeSixSubscribeSectionGeneratedProps>(
      "HomeSixSubscribeSection",
    );

  return (
    <HomeSixSubscribeSectionGenerated
      {...defaults}
      sectionDiv0Div0Div0Div0H20H2Text={
        props.setting.Title ?? defaults.sectionDiv0Div0Div0Div0H20H2Text
      }
      sectionDiv0Div0Div0Div1Div0Form0Input0InputPlaceholder={
        props.setting.Placeholder ??
        defaults.sectionDiv0Div0Div0Div1Div0Form0Input0InputPlaceholder
      }
      sectionDiv0Div0Div0Div1Div0Form0FormRenderer={() => (
        <FooterNewsletterForm
          buttonClassName="btn-icon btn btn-secondary"
          buttonContent={<i className="isax isax-arrow-right-1" />}
          inputClassName="form-control"
          placeholder={
            props.setting.Placeholder ??
            defaults.sectionDiv0Div0Div0Div1Div0Form0Input0InputPlaceholder
          }
        />
      )}
    />
  );
};

export default GeneratedNewsletterSection;
